<template>
    <v-select
        v-model="query.stage"
        v-bind="{
            ...attrs_input,
            loading,
            items,
            label: '지원상태',
        }"
        @input="emit"
    />
</template>

<script>
import { RECRUITMENT_KANBAN_FIELDS, attrs_input } from "@/assets/variables";

const items = [{ text: "전체", value: null }].concat(Object.values(RECRUITMENT_KANBAN_FIELDS).map(({ text, stage }) => ({ text, value: stage })));

const initQuery = (query = {}) => ({
    ...(query || {}),
    stage: query.stage || null,
});

export default {
    props: {
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),
        focused: false,

        attrs_input,
        items,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query.sort) delete query.sort;

            this.$router.push({ query });
        },
    },
};
</script>

<style lang="scss" scoped></style>
